
(function() {
    'use strict';
    
    // Function to update counter styles based on current values
    function updateCounterStyles() {
        // Update cart counter
        const cartCounter = document.querySelector('[data-cart-count]');
        if (cartCounter) {
            const cartCount = parseInt(cartCounter.textContent) || 0;
            cartCounter.classList.toggle('has-items', cartCount > 0);
        }
        
        // Update wishlist counter
        const wishlistCounter = document.querySelector('[data-count-wishlist]');
        if (wishlistCounter) {
            const wishlistCount = parseInt(wishlistCounter.textContent) || 0;
            wishlistCounter.classList.toggle('has-items', wishlistCount > 0);
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateCounterStyles);
    } else {
        updateCounterStyles();
    }
    
    // Update when cart changes (Shopify's built-in event)
    document.addEventListener('ajaxCart.afterCartLoad', updateCounterStyles);
    
    // Update on any AJAX complete
    document.addEventListener('ajaxComplete', function() {
        setTimeout(updateCounterStyles, 100);
    });
    
    // MutationObserver for dynamic changes
    if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function(mutations) {
            let shouldUpdate = false;
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    shouldUpdate = true;
                }
            });
            if (shouldUpdate) {
                updateCounterStyles();
            }
        });
        
        // Start observing when counters are available
        function startObserving() {
            const cartCounter = document.querySelector('[data-cart-count]');
            const wishlistCounter = document.querySelector('[data-count-wishlist]');
            
            const config = { 
                childList: true, 
                characterData: true, 
                subtree: true 
            };
            
            if (cartCounter) observer.observe(cartCounter, config);
            if (wishlistCounter) observer.observe(wishlistCounter, config);
        }
        
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', startObserving);
        } else {
            startObserving();
        }
    }
    
    // Update when page becomes visible again
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
            updateCounterStyles();
        }
    });
    
    // Fallback: periodic check every 2 seconds
    setInterval(updateCounterStyles, 2000);
    
})();